module.exports = __webpack_public_path__ + "static/media/About Us.c4bd41b0.png";